import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../../../styles/media'
import { colors } from '../../../../styles/theme'

const S = {}

S.Offcanvas = styled.div`
  position: fixed;
  width: 100%;
  color: ${colors.white};
  background-color: ${({ lightMode }) =>
    lightMode ? colors.white : colors.woodsmoke};
  overflow-y: auto;
  opacity: 0;
  visibility: hidden;
  top: 3.75rem;
  height: calc(100% - 3.75rem);
  z-index: 1050;
  transition: transform 0.1s, opacity 0.1s cubic-bezier(0, 0, 0.25, 1),
    visibility 0s linear 0.1s;

  html:not([dir]) &,
  [dir='ltr'] & {
    left: 0;
    transform: translateX(-1.5625rem);
  }

  [dir='rtl'] & {
    right: 0;
    transform: translateX(101%);
  }

  ${media.sm`
    width: 18.75rem;
  `};

  ::-webkit-scrollbar {
    width: 0.75rem;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${colors.scarpaFlow};
    border: 0.1875rem solid
      ${({ lightMode }) => (lightMode ? colors.alabaster : colors.shark)};

    &:active {
      background-color: ${colors.silverChalice};
      border: 0.125rem solid
        ${({ lightMode }) => (lightMode ? colors.alabaster : colors.shark)};
    }

    @media (hover: hover) {
      &:hover {
        background-color: ${colors.silverChalice};
        border: 0.125rem solid
          ${({ lightMode }) => (lightMode ? colors.alabaster : colors.shark)};
      }
    }
  }

  ::-webkit-scrollbar-track {
    background-color: ${({ lightMode }) =>
      lightMode ? colors.alabaster : colors.shark};
  }

  a {
    text-decoration: none;
    transition: none;
  }

  .section {
    padding: 0.625rem 0;

    &:first-of-type {
      border-bottom: 0.125rem solid
        ${({ lightMode }) => (lightMode ? '#dedede' : colors.shark)};
    }
  }

  .title {
    display: block;
    font-size: 0.75rem;
    text-transform: uppercase;
    color: ${({ lightMode }) =>
      lightMode ? colors.scarpaFlow : colors.silverChalice};
    font-weight: ${({ lightMode }) => (lightMode ? 700 : 600)};
    line-height: 1.33;
    padding: 0.625rem 1.125rem;
  }

  .menu {
    list-style-type: none;
    padding-left: 0;
    padding-right: 0;
    margin: 0;
  }

  .menu-item {
    cursor: pointer;
    user-select: none;
  }

  .menu-item-title {
    display: block;
    color: ${({ lightMode }) => (lightMode ? colors.shark : colors.alabaster)};
    padding: 0.75rem 1.125rem;
    line-height: 1.5;
    font-weight: ${({ lightMode }) => lightMode && 500};

    @media (hover: hover) {
      &:hover {
        background-color: ${({ lightMode }) =>
          lightMode ? '#f2f2f2' : colors.shark};
        color: ${({ lightMode }) => lightMode && colors.orange};
      }
    }

    &:active {
      background-color: ${({ lightMode }) => lightMode && '#dedede'};
    }

    &.active {
      border: 0 solid
        ${({ lightMode }) => (lightMode ? colors.orange : colors.scooter)};
      color: ${({ lightMode }) => (lightMode ? colors.orange : colors.white)};
      background-image: ${({ lightMode }) =>
        !lightMode &&
        'linear-gradient(to left, rgba(74, 78, 88, 0.5), rgba(74, 78, 88, 1))'};

      html:not([dir]) &,
      [dir='ltr'] & {
        border-left-width: 0.125rem;
      }

      [dir='rtl'] & {
        border-right-width: 0.125rem;
      }
    }
  }

  ${({ menuIsOpen }) =>
    menuIsOpen &&
    css`
      opacity: 1;
      visibility: visible;
      transition: transform 0.15s, opacity 0.15s cubic-bezier(0, 0, 0.25, 1),
        visibility 0s;

      html:not([dir]) &,
      [dir='ltr'] &,
      [dir='rtl'] & {
        transform: translateX(0);
      }
    `};
`

export default S
